<template>
  <div class="input-select">
    <select v-model="sortSelect">
      <option value="created-asc">
        {{ trans('user.invoice.sort.created_asc') }}
      </option>
      <option value="created-desc">
        {{ trans('user.invoice.sort.created_desc') }}
      </option>
      <option value="total-desc">
        {{ trans('user.invoice.sort.total_desc') }}
      </option>
      <option value="total-asc">
        {{ trans('user.invoice.sort.total_asc') }}
      </option>
    </select>
  </div>
</template>

<script>
import { translationMixin } from '@elements/translation';

export default {
  name: 'InvoiceSort',
  mixins: [ translationMixin ],
  props: {
    sort: { type: String, required: true },
  },
  computed: {
    sortSelect: {
      get() {
        return this.sort;
      },
      set(newValue) {
        this.$emit('change', newValue);
      },
    },
  },
};
</script>
